// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__5aCxe","col":"styles_col__HPEr0"};